// Ami Communicator API - Integration types
const INTEGRATION_TYPES = Object.freeze({
  EMAIL_HELPDESK: 'email_helpdesk'
})

// SendGrid template IDs for email integrations
const SENDGRID_TEMPLATES = Object.freeze({
  HTML: 'd-1303a8eeba1f405ebda2e2a439783833',
  TEXT: 'd-38bb93ebccc94f3ebc9be71181eb16e7'
})

// Email format types
const EMAIL_FORMATS = Object.freeze({
  HTML: 'html',
  TEXT: 'text'
})

export { INTEGRATION_TYPES, SENDGRID_TEMPLATES, EMAIL_FORMATS }

